import { axios_institute_public } from "../../../../api/setup.intersepter";

export const getTnc = () => {
  return axios_institute_public({
    method: "GET",
    url: `/termsnconditions/?tncType=BOTH`,
  });
};
